import { type Dtos, type SuretyAccountId } from "@inrev/common";
import { useAuthenticatedUser } from "@portal/providers/AuthenticatedUserProvider";
import { useQuery } from "@tanstack/react-query";
import { useRequest } from "../../utils/request";
import { wipExtractionsQueryKey } from "./wip.keys";

export const useFetchWipExtractions = (accountId: SuretyAccountId, enabled: boolean = true) => {
	const { get } = useRequest();
	const { isAdmin } = useAuthenticatedUser();

	const { data, error, isLoading, refetch } = useQuery({
		queryKey: wipExtractionsQueryKey(accountId),
		enabled,
		queryFn: async () =>
			await get<Dtos.Wip.Extraction.Get.Response[]>(
				`/v2/${isAdmin ? "admin/" : ""}surety/accounts/${accountId}/wip-extractions`,
			),
	});

	return {
		wipExtractions: data,
		wipExtractionsError: error,
		wipExtractionsLoading: isLoading,
		refetchWipExtractions: refetch,
	};
};
